module.exports = __webpack_public_path__ + "img/left_pic.c15834e2.png";